import ChartWidget from './ChartWidget.vue';
import KpiWidget from './KpiWidget.vue';
import TableWidget from './TableWidget.vue';
import TextWidget from './TextWidget.vue';
import HeadingWidget from './HeadingWidget.vue';
import SheetWidget from './SheetWidget.vue';

export const STOCK_WIDGETS = {
  chart: ChartWidget,
  kpi: KpiWidget,
  table: TableWidget,
  text: TextWidget,
  heading: HeadingWidget,
  sheet: SheetWidget,
};

export function stockComponent(name) {
  return STOCK_WIDGETS[name] || null;
}
